<template>
   <div class="modal-dialog modal-dialog-scrollable modal-lg">

      <div class="modal-content">

         <div class="modal-header">
            <div class="d-flex align-items-start">
               <h3 class="modal-title" style="color:#f4fbff"><strong> Notes </strong></h3>
            </div>
            <div class="d-flex align-items-end">
               <button ref="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetForm()"></button>
            </div>
         </div>

         <div class="modal-body px-4">

            <div class="row pb-1">
               <h3 class="modal-title"><strong> {{ lead.organisation }}</strong></h3>
            </div>

            <form class="row g-0" style="gap: 0.5rem">

               <div class="form-floating">
                  <textarea class="form-control" id="enquiryDetails" v-model.trim="enquiryDetails"
                     placeholder="Write additional notes..." style="height: 100px"></textarea>
                  <label for="enquiryDetails" class="text-muted">Write additional notes...</label>
               </div>

               <div class="mb-3 text-end">
                  <button type="button" class="btn btn-info text-light" @click="createLeadNote(lead.id)" 
                     :disabled="disableAddNoteButton()"> Add </button>
               </div>
            </form>

            <div class="row px-3" v-for="leadNote in leadNotes" :key="leadNote.id">

               <div class="card">

                  <div class="card-body" style="white-space: pre-wrap;">

                     <!-- LEAD CREATED NOTE -->
                     <div v-if="leadNote.note_type == 'initial_status'" 
                        class="d-row d-flex" style="gap: 0.2rem">
                        <div v-if="leadNote.user"> {{ leadNote.user.firstName + " " + leadNote.user.lastName }}</div>
                        <span class="ps-1" :class="leadNote.note_type.toLowerCase()">Created lead</span>
                        
                        <p class="text-end" style="font-size:10px" :title="formatDate(leadNote.date_updated, 'full')">
                           {{ formatDate(leadNote.date_created) }}
                        </p>
                     </div>
                     <!-- END -- LEAD CREATED NOTE -->

                     <!-- LEAD CREATED NOTE FROM INTERNAL FORM -->
                     <div v-else-if="leadNote.note_type == 'initial_status_internal'" 
                        class="d-row d-flex" style="gap: 0.2rem">
                        <span class="pe-1" :class="leadNote.note_type.toLowerCase()">From internal form - Created lead</span>
                        
                        <p class="text-end" style="font-size:10px" :title="formatDate(leadNote.date_updated, 'full')">
                           {{ formatDate(leadNote.date_created) }}
                        </p>
                     </div>
                     <!-- END -- LEAD CREATED NOTE FROM INTERNAL FORM -->

                     <!-- LEAD CREATED NOTE FROM PENTEST FORM -->
                     <div v-else-if="leadNote.note_type == 'initial_status_pentest'" 
                        class="d-row d-flex" style="gap: 0.2rem">
                        <span class="pe-1" :class="leadNote.note_type.toLowerCase()">From pentest form - Created lead</span>
                        
                        <p class="text-end" style="font-size:10px" :title="formatDate(leadNote.date_updated, 'full')">
                           {{ formatDate(leadNote.date_created) }}
                        </p>
                     </div>
                     <!-- END -- LEAD CREATED NOTE FROM PENTEST FORM -->

                     <!-- LEAD CREATED NOTE FROM WEBSITE FORM -->
                     <div v-else-if="leadNote.note_type == 'initial_status_website'" 
                        class="d-row d-flex" style="gap: 0.2rem">
                        <span class="pe-1" :class="leadNote.note_type.toLowerCase()">From website contact form - Created lead</span>
                        
                        <p class="text-end" style="font-size:10px" :title="formatDate(leadNote.date_updated, 'full')">
                           {{ formatDate(leadNote.date_created) }}
                        </p>
                     </div>
                     <!-- END -- LEAD CREATED NOTE FROM WEBSITE FORM -->

                     <!-- STATUS/PRIORITY CHANGE NOTE -->
                     <div v-else-if="leadNote.note_type == 'status' || leadNote.note_type == 'priority' || leadNote.note_type == 'specific_status'" class="d-row d-flex" style="gap: 1rem">

                        <div v-if="leadNote.user"> {{ leadNote.user.firstName + " " + leadNote.user.lastName }}</div>

                        <div :class="leadNote.note_type.toLowerCase()">
                           <span class="pe-1"> {{ leadNote.note_type === 'specific_status' ? 'Priority' : formatToTitleCase(leadNote.note_type) }} change: </span>

                           <span v-if="leadNote.note_type == 'status'" class="pe-1 prevStatus">{{ formatStatusDisplay(statusChange(leadNote.note_details)[0]) }}</span>
                           <span v-if="leadNote.note_type == 'priority' || leadNote.note_type == 'specific_status'" class="pe-1" :class="statusChange(leadNote.note_details)[0].toLowerCase()">{{ formatStatusDisplay(statusChange(leadNote.note_details)[0]) }}</span>
                           
                           <span class="pe-1"><i class="fa fa-arrow-right"></i></span>
                           
                           <span v-if="leadNote.note_type == 'status'" class="pe-1 newStatus">{{ formatStatusDisplay(statusChange(leadNote.note_details)[1]) }}</span>
                           <span v-if="leadNote.note_type == 'priority' || leadNote.note_type == 'specific_status'" class="pe-1" :class="statusChange(leadNote.note_details)[1].toLowerCase()">{{ formatStatusDisplay(statusChange(leadNote.note_details)[1]) }}</span>
                        </div>
                        
                        <p style="font-size:10px" :title="formatDate(leadNote.date_updated, 'full')">
                           {{ formatDate(leadNote.date_created) }}
                        </p>
                     </div>  
                     <!-- END -- STATUS/PRIORITY CHANGE NOTE -->

                     <!-- AUTH ORGANISATION LINK -->
                     <div v-else-if="leadNote.note_type == 'auth_org_link'" class="d-row d-flex" style="gap: 1rem">

                        <div v-if="leadNote.user"> {{ leadNote.user.firstName + " " + leadNote.user.lastName }}</div>
                        
                        <div :class="leadNote.note_type.toLowerCase()">
                           <span class="pe-1"> Auth Organisation change: </span>

                           <span v-if="!leadNote.note_details.includes('-')" class="auth_org_link_details">{{ leadNote.note_details }}</span>
                           
                           <span v-else>
                              <span class="auth_org_link_details">{{ authOrgChange(leadNote.note_details)[0] + " - " }}</span>
                              <span class="auth_org_link_details" style="font-weight:900">{{ authOrgChange(leadNote.note_details)[1] }}</span>
                           </span>
                           
                        </div>
                        
                        <p style="font-size:10px" :title="formatDate(leadNote.date_updated, 'full')">
                           {{ formatDate(leadNote.date_created) }}
                        </p>
                     </div>  
                     <!-- END -- AUTH ORGANISATION LINK -->
                     
                     <!-- LEAD NOTES -->
                     <div v-else>

                        <div class="d-row d-flex" style="gap: 0.2rem">
                           <div class="pe-1" v-if="leadNote.note_type == 'initial_note_internal'" style="font-size:12px;font-style: italic;">From internal form</div>
                           <div class="pe-1" v-if="leadNote.note_type == 'initial_note_pentest'" style="font-size:12px;font-style: italic;">From pentest form</div>
                           <div class="pe-1" v-if="leadNote.note_type == 'initial_note_website'" style="font-size:12px;font-style: italic;">From website contact form</div>
                           <div v-if="leadNote.user"> {{ leadNote.user.firstName + " " + leadNote.user.lastName }}</div>
                           <div v-if="leadNote.date_created != leadNote.date_updated"> 
                              <span style="font-size:10px;font-style: italic;">(edited)</span>
                           </div>
                           <p class="text-end" style="font-size:10px" :title="formatDate(leadNote.date_updated, 'full')">
                              {{ formatDate(leadNote.date_updated) }}
                           </p>
                        </div>
                        

                        <!-- WHEN NOT EDITING -->
                        <div v-if="editingData != leadNote.id" class="d-row d-flex" style="gap: 0.5rem">
                           <span v-if="showEditButton(leadNote.created_by, leadNote.date_created)" 
                              title="Click to edit" 
                              @click="isEdit(leadNote)" > 
                              <i class="fa fa-pen" style="color:#00a0c1; cursor:pointer"></i>
                           </span>

                           <!-- For Lost Lead Reason -->
                           <p :class="leadNote.note_type.toLowerCase()">
                              <span class="text-muted" v-if="leadNote.note_type == 'loss_reason'" 
                                 style="font-style:italic">Lost Lead - Reason: </span>
                              <span>{{ leadNote.note_details }}</span>
                           </p>
                        </div>
                        <!-- END -- WHEN NOT EDITING -->

                        <!-- WHEN EDITING -->
                        <div v-if="isEditing && editingData == leadNote.id">
                           <textarea ref="editNoteRef" class="form-control" id="editNote" v-model.trim="leadNote.note_details"></textarea>

                           <div class="d-row d-flex pt-2 justify-content-end" style="gap: 0.5rem">
                              <button type="button" class="btn btn-outline-warning"
                              title="Click to cancel" @click="cancelEdit(leadNote)">Cancel</button>
                              <button type="button" class="btn btn-outline-info"
                              title="Click to save" @click="updateLeadNote(leadNote)" 
                              :disabled="disableEditNoteButton(leadNote.note_details)">Save</button>
                           </div>
                           
                        </div>
                        <!-- END -- WHEN EDITING -->

                     </div>
                     <!-- END -- LEAD NOTES -->
                     
                  </div>

               </div>

               <hr>

            </div>

         </div>

      </div>
      
   </div>
   
</template>

<script>
import moment from "moment";
import { toTitleCase } from '@/plugins/helper.js'

export default {

	data() {
		return {
         lead: {
            id: '',
            organisation: '',
         },
         leadNotes: [],
         leadNote: {
            id: '',
            noteType: '',
            noteDetails: '',
            lead: '',
            createdBy: '',
         },
         enquiryDetails: '',
			currentDate: null,
         isEditing: false,
         editingData: '',
         
		}
	},

	methods: {
		init(id) {
			this.currentDate = moment(new Date()).format("DD-MMM-YYYY");
         this.getLead(id)
         this.getLeadNotes(id)
		},

      formatDate(date, type){
         if (type == "full") {
            return moment(date).format("DD-MMM-YYYY h:mm A")
         } else {
            return moment(date).format("DD-MMM-YYYY")
         }
         
      },

      formatToTitleCase(str) {
         return toTitleCase(str)
      },

      resetForm() {
         this.leadNote.noteDetails = ''
         this.enquiryDetails = ''
         this.isEditing = false
         this.editingData = ''
      },

      disableAddNoteButton(){
         return this.enquiryDetails.trim() == ""
      },

      showEditButton(userId, dateCreated) {

         // get duration from date created to today
         let currentDate = moment(new Date(), "DD/MM/YYYY")
         let noteDateCreated = moment(new Date(dateCreated), "DD/MM/YYYY")

         let duration = currentDate.diff(noteDateCreated, 'days') + 1;

         // disable editing if commentor is not the user logged in and
         // if comment has exceeded 7 days from creation date
         if (this.$store.state.auth.jwtPayload.user_id == userId &&
               duration <= 7){
            return true
         }

         return false
      },

      isEdit(data){
         this.isEditing = true
         this.editingData = data.id
         this.getLeadNote(data.lead_id, data.id)

         // Keep track of the original data
         this._beforeEditingCache = Object.assign({}, data);

         //set height of edit note text area to fit content
         this.$nextTick(()=>{
            const textarea = this.$refs.editNoteRef
            textarea[0].style.height = textarea[0].scrollHeight + 2 + 'px';
         });

      },

      cancelEdit(data){
         // Return the data back to it’s previous state
         Object.assign(data, this._beforeEditingCache);

         this.resetForm()
         this._beforeEditingCache = ''

      },

      //disable save button when no changes have been made
      disableEditNoteButton(updatedNote){
         return updatedNote == this._beforeEditingCache.note_details
      },

      formatStatusDisplay(str) {
         if (!str) return ''
         // Replace underscores with spaces
         let formatted = str.replace(/_/g, ' ')
         // Add a space before a capital letter, but not at the start of the string
         formatted = formatted.replace(/([A-Z])/g, ' $1').trim()
         // Capitalize each word (Title Case)
         return formatted.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
         });
      },

      statusChange(value){
         let str = value

         let statusChange = str.split(",").map(item=>item.trim())
 
         return statusChange
      },

      authOrgChange(value){
         let str = value
         
         if (str.includes(" - ")) {
            str = str.split(" - ").map(item=>item.trim())
         }
         
         return str
      },

      async getLead(id) {

         await this.$axios.get("/leads/"+id)
         .then((response) => {
            this.lead.id = response.data.lead.id
            this.lead.organisation = response.data.lead.organisation_name
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
         
      },

      async getLeadNote(leadId, noteId) {

         await this.$axios.get("/leads/"+leadId+"/notes/"+noteId)
         .then((response) => {

            this.leadNote.id = response.data.note.id
            this.leadNote.noteType = response.data.note.note_type
            this.leadNote.noteDetails = response.data.note.note_details
            this.leadNote.lead = response.data.note.lead_id
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
         
      },

      async getLeadNotes(id) {

         await this.$axios.get("/leads/"+id+"/notes")
         .then((response) => {
            this.leadNotes = response.data.items
            this.getUser()
               
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
         
      },

      // Call get users api in Auth
      async getAuthUser(id, index){
         await this.$axios_auth.get("/users/"+id)
         .then((response) => {

            if (response.data.user) {
               let user = {
                  firstName: response.data.user.first_name,
                  lastName: response.data.user.last_name
               }

               this.leadNotes[index].user = user
            }
            
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },

      // loop through the notes and get user 
      getUser(){
         for (let i in this.leadNotes) {
            let userId = this.leadNotes[i].created_by

           this.getAuthUser(userId, i)
         }
      },

      async createLeadNote(id){

         let leadNote = {
            note_type : 'note',
            note_details : this.enquiryDetails,
            lead_id : id,
         }
         
         await this.$axios.post("/leads/"+id+"/notes",leadNote)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)

               this.resetForm();

               this.getLeadNotes(id)
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
         
      },

      async updateLeadNote(data){

         let leadNote = {
            note_details : data.note_details,
         }

         let leadId = data.lead_id
         let noteId = data.id
         
         await this.$axios.put("/leads/"+leadId+"/notes/"+noteId,leadNote)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)

               this.resetForm();

               this.getLeadNotes(leadId)
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
         
      },
	},
};

</script>

<style scoped>

.status, .priority, .specific_status,
.initial_status, .initial_status_internal, 
.initial_status_pentest, .initial_status_website,
.auth_org_link {
   font-style: italic;
   font-size: 12px;
}

.note, .initial_note, 
.initial_note_internal, .initial_note_pentest, 
.initial_note_website, .loss_reason{
   font-size: 13px;
}

.prevStatus{
   color: #F3994D;
}

.newStatus {
   color: #00A54F;
}

.high{
   color: #EB1C24;
}

.low{
   color: #00A54F;
}

.medium{
   color: #F3994D;
}

.auth_org_link_details{
   color: #00A0C1;
}

</style>